
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/agent-alerting",
      function () {
        return require("private-next-pages/ai-decisioning/agent-alerting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/agent-alerting"])
      });
    }
  